/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function setCookie(cname, cvalue, exdays) {
  localStorage.setItem('location', cvalue);
}

function getCookie(cname) {
   return localStorage.getItem('location');

}

function string_to_slug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

/* This controls the calendar */
$(document).ready(function() {
  
  if($('.delivery-options-container').length > 0) {
   //console.log(string_to_slug(getCookie('your-location')));
    $('.cart-location.'+string_to_slug(getCookie('your-location'))).show();
    
  }
  
    $(function() {
        $("#date").datepicker({
            minDate:0,
            /* This adds a day to the a calendar */
            maxDate: '+2M',
            beforeShowDay: function(date) {
                var day = date.getDay();
                return [(day != -1), ''];
            }
        });
      

      
      $('#your-location').niceSelect();
      
      if(getCookie('your-location')) {
      $('#your-location').val(getCookie('your-location')).niceSelect('update');
      }
      
      $('.SizeSwatchList li input').each(function() {
        $(this).removeAttr('checked');
      });
      
      $('.SizeSwatchList li label').each(function() {
        if($(this).text() == $('#your-location').val()) {
          $(this).click();
        }
      });
      


    });


    var checkoutBtn = document.getElementsByClassName("Cart__Checkout")[0];

    $('.required').bind('keyup click change', function() {

        let empty = false;

        var result = [];
        $('.required').each(function() {

            if (this.classList.contains('options-radio')) {
                var radioBtn = document.getElementsByClassName("options-radio");
                if ((radioBtn[0].checked == false) && (radioBtn[1].checked == false)) {
                    result.push(false);
                } else {
                    result.push(true);
                }
                if (radioBtn[0].checked == true) {
                    $('.date-label').html('Delivery Date');
                    $("#pickup-time").html('Delivery Time');
                } else if (radioBtn[1].checked == true) {
                    $('.date-label').html('Pickup Date');
                    $("#pickup-time").html('Pickup Time');
                }
            } else if (this.classList.contains('date-picker')) {
                var datePicker = document.getElementsByClassName("date-picker")[0];
                if ($('#date').datepicker('getDate')) {
                    result.push(true);
                } else {
                    result.push(false);
                }
            } else {
                if ($(this).val().length == 0) {
                    result.push(false);
                } else {
                    result.push(true);
                }
            }
            console.log(result);
        });


        let checker = arr => arr.every(v => v === true);
        var allCheck = checker(result);

        if (!allCheck) {
            checkoutBtn.setAttribute('disabled', 'disabled');
            checkoutBtn.setAttribute('data-action', '');
            $('.notification')[0].setAttribute('style', 'color:red; padding:10px 0; display:block; visibility:visible;');
        } else {
            checkoutBtn.removeAttribute('disabled');
            checkoutBtn.setAttribute('data-action', 'add-to-cart');
            $('.notification')[0].setAttribute('style', 'display:none;');
        }
    });

});